import React, {ReactNode, useEffect, useState} from 'react';
import {
    ZooPassLocalStateDataFinalizeItemState,
    ZooPassLocalStateDataFinalizeItemStateStatus,
    ZooPassLocalStateDataFinalizeState
} from "../../Data/ZooPassLocalStateData";
import {useZooPassAppContext} from "../../Context/ZooPassAppContext";
import Button from 'react-bootstrap/Button';

export interface FinalizingStepsPanelProps {
    finalizingState?: ZooPassLocalStateDataFinalizeState | null;
}

export const FinalizingStepsPanel: React.FC<FinalizingStepsPanelProps> = ({finalizingState}) => {
    
    let list : ReactNode[] = [];
    if(finalizingState != null){
        if(finalizingState.initializing) list.push(<FinalizingStepsItemPanel item={finalizingState.initializing}/>);
        if(finalizingState.getChildrenSelection) list.push(<FinalizingStepsItemPanel item={finalizingState.getChildrenSelection}/>);
        if(finalizingState.login) list.push(<FinalizingStepsItemPanel item={finalizingState.login}/>);
        if(finalizingState.setChildren) list.push(<FinalizingStepsItemPanel item={finalizingState.setChildren}/>);
        if(finalizingState.redirecting) list.push(<FinalizingStepsItemPanel item={finalizingState.redirecting}/>);
    }
    
    return finalizingState != null && <>
        <div
            className="finalizing-steps-panel row g-4 align-items-center justify-content-center">
            <div className="col-12 col-sm-11 col-md-9 col-lg-7 col-xl-4">
                {list}
            </div>
        </div>
    </> || <></>;
}

export interface FinalizingStepsItemPanelProps {
    item?: ZooPassLocalStateDataFinalizeItemState | null | undefined;
}

export const FinalizingStepsItemPanel: React.FC<FinalizingStepsItemPanelProps> = ({item}) => {
    //Dumb workaround
    const [itemDescription, setItemDescription] = useState<string>("");
    useEffect(() => {
        if(itemDescription == item?.description) return;
        if(item && item.description && item.description.length > 0) {
            console.log("filled item description", item.description);
            setItemDescription(item.description);
        }else{
            setItemDescription("");
        }
    },[item?.description]);
    
    return item && (<>
        <div className="row my-2">
            <div className="col-1 icon-items">
                {item.status == ZooPassLocalStateDataFinalizeItemStateStatus.Disabled &&
                    <FinalizingStepsItemStateIconDisabled/>}
                {item.status == ZooPassLocalStateDataFinalizeItemStateStatus.Ready &&
                    <FinalizingStepsItemStateIconReady/>}
                {item.status == ZooPassLocalStateDataFinalizeItemStateStatus.Current &&
                    <FinalizingStepsItemStateIconCurrent/>}
                {item.status == ZooPassLocalStateDataFinalizeItemStateStatus.Failed &&
                    <FinalizingStepsItemStateIconFailed/>}
                {item.status == ZooPassLocalStateDataFinalizeItemStateStatus.Success &&
                    <FinalizingStepsItemStateIconSuccess/>}
                {item.status == ZooPassLocalStateDataFinalizeItemStateStatus.Unknown &&
                    <FinalizingStepsItemStateIconUnknown/>}
            </div>
            <div className="col-11">
                <div className="w-100 label-column"><h6>{item.label}</h6></div>
                <div className="w-100 description-column">{itemDescription}&nbsp;</div>
            </div>
        </div>
    </>) || <></>
}

export interface FinalizingStepsButtonRowSegmentProps {
    clickCallback?: () => void;
    headingDictionaryKey?: string | null | undefined;
    buttonTextDictionaryKey: string;
}


export const FinalizingStepsButtonRowSegment: React.FC<FinalizingStepsButtonRowSegmentProps> = 
    ({clickCallback, headingDictionaryKey, buttonTextDictionaryKey}) => {
    let {
        dictionary,
        loading
    } = useZooPassAppContext();

    const handleLoginClick = () => {
        if (clickCallback != null) {
            clickCallback();
        }
    }

    return !loading && <div
        className="row g-4 align-items-center justify-content-center row-cols-lg-2 row-cols-1">
        <div className="col">
            <div className="m-4 d-flex justify-content-center">
                <div className="my-1 mx-5 w-100">
                    {headingDictionaryKey && <h3>{dictionary.get(headingDictionaryKey)}</h3>}
                    <Button type="button" tabIndex={0}
                            className="btn btn-default w-100 border-2 border-black rounded-0 zoopass--step8--choose-pass-button"
                            onClick={handleLoginClick}>{dictionary.get(buttonTextDictionaryKey)}
                    </Button>
                </div>
            </div>
        </div>
    </div>
}

/**
 * Disabled
 * @see https://icons.getbootstrap.com/icons/ban-fill/
 */
export const FinalizingStepsItemStateIconDisabled: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                className="bi bi-ban-fill state-icon icon-disabled" viewBox="0 0 16 16">
        <path
            d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M2.71 12.584q.328.378.706.707l9.875-9.875a7 7 0 0 0-.707-.707l-9.875 9.875Z"/>
    </svg>
}

/**
 * Ready
 * @see https://icons.getbootstrap.com/icons/square/
 */
export const FinalizingStepsItemStateIconReady: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                className="bi bi-square state-icon icon-ready" viewBox="0 0 16 16">
        <path
            d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
    </svg>
}

/**
 * Current
 * @see https://icons.getbootstrap.com/icons/hourglass-split/
 */
export const FinalizingStepsItemStateIconCurrent: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                className="bi bi-hourglass-split state-icon icon-current" viewBox="0 0 16 16">
        <path
            d="M2.5 15a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1zm2-13v1c0 .537.12 1.045.337 1.5h6.326c.216-.455.337-.963.337-1.5V2zm3 6.35c0 .701-.478 1.236-1.011 1.492A3.5 3.5 0 0 0 4.5 13s.866-1.299 3-1.48zm1 0v3.17c2.134.181 3 1.48 3 1.48a3.5 3.5 0 0 0-1.989-3.158C8.978 9.586 8.5 9.052 8.5 8.351z"/>
    </svg>
}

/**
 * Failed
 * @see https://icons.getbootstrap.com/icons/hourglass-split/
 */
export const FinalizingStepsItemStateIconFailed: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                className="bi bi-exclamation-square-fill state-icon icon-failed" viewBox="0 0 16 16">
        <path
            d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm6 4c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995A.905.905 0 0 1 8 4m.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/>
    </svg>
}

/**
 * Success
 * @see https://icons.getbootstrap.com/icons/hourglass-split/
 */
export const FinalizingStepsItemStateIconSuccess: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                className="bi bi-check-square-fill state-icon icon-success" viewBox="0 0 16 16">
        <path
            d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm10.03 4.97a.75.75 0 0 1 .011 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.75.75 0 0 1 1.08-.022z"/>
    </svg>
}

/**
 * Success
 * @see https://icons.getbootstrap.com/icons/question-square/
 */
export const FinalizingStepsItemStateIconUnknown: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-question-square state-icon icon-unknown" viewBox="0 0 16 16">
        <path
            d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
        <path
            d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286m1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94"/>
    </svg>
}